import React from 'react';

const Services = () => {
  // Static services data - no API needed
  const services = [
    {
      title: 'Game Development',
      description: 'We develop high-quality games and interactive experiences across multiple platforms. What we build: PC and Mobile Games, Multiplayer and Online Systems, Simulation and Training Applications, Real-time 3D Experiences. Technologies: Unity, Unreal Engine, C++, C#, Blueprint, Custom Tooling. Who it\'s for: Indie studios, startups, enterprises, and simulation-based projects.',
      icon: 'fas fa-gamepad'
    },
    {
      title: 'Website Development',
      description: 'We design and build fast, secure, and scalable web applications. Capabilities: Custom web applications, Backend systems and APIs, Admin dashboards, Performance optimization. Technologies: React, Next.js, Node.js, Python, Django, PostgreSQL, Cloud Services.',
      icon: 'fas fa-globe'
    },
    {
      title: 'Android & iOS Applications',
      description: 'Native and cross-platform mobile applications designed for performance and usability. What we deliver: Consumer mobile apps, Enterprise tools, API-integrated systems, App Store & Play Store deployment. Technologies: Kotlin, Swift, Flutter, React Native.',
      icon: 'fas fa-mobile-alt'
    },
    {
      title: 'AI & Machine Learning',
      description: 'We design and deploy practical AI systems that solve real problems. Solutions include: Computer vision systems, Predictive analytics, Recommendation engines, NLP and data-driven automation. Focus: Model performance, data quality, and real-world deployment.',
      icon: 'fas fa-brain'
    },
    {
      title: 'Generative AI Systems',
      description: 'We build custom generative AI solutions beyond off-the-shelf APIs. Use cases: AI chatbots and assistants, Image, text, and content generation, Workflow automation using LLMs, Fine-tuned models for private data. Approach: Security-aware, scalable, and production-ready.',
      icon: 'fas fa-robot'
    },
    {
      title: 'Deep Tech R&D',
      description: 'For problems that don\'t have obvious answers. Areas of work: Advanced simulations, Computer vision & perception, AI-driven systems, Experimental prototypes, Research-to-product pipelines. We collaborate closely with clients to turn research into deployable systems.',
      icon: 'fas fa-microchip'
    }
  ];

  return (
    <section id="services" className="section">
      <div className="container">
        <h2 className="section-title">What We Do</h2>
        <div className="grid-3">
          {services.map((service, index) => (
            <div key={index} className="card service-card">
              <div className="service-icon-wrapper">
                <i className={`${service.icon} icon`}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
  {/* tagline removed per request */}
        <div className="why-compilex">
          <h2 className="section-title">Why CompileX</h2>
          <p>We are not a generic outsourcing studio.</p>
          <ul className="check-list">
            <li><i className="fas fa-check-circle"></i> Engineering-first mindset</li>
            <li><i className="fas fa-check-circle"></i> Research-driven development</li>
            <li><i className="fas fa-check-circle"></i> Strong focus on performance and scalability</li>
            <li><i className="fas fa-check-circle"></i> Experience with complex, non-standard problems</li>
            <li><i className="fas fa-check-circle"></i> Transparent communication and structured delivery</li>
          </ul>
          <p>We build software that lasts.</p>
        </div>
        <div className="industries-serve">
          <h2 className="section-title">Industries We Serve</h2>
          <div className="grid-3">
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-gamepad"></i>
              </div>
              <h3>Gaming & Interactive Media</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>Startups & Product Teams</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-building"></i>
              </div>
              <h3>Enterprise Software</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-flask"></i>
              </div>
              <h3>Research & Innovation Labs</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>Simulation & Visualization</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">
                <i className="fas fa-heartbeat"></i>
              </div>
              <h3>Healthcare & Life Sciences</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
